import React, { useState, useEffect, useContext } from 'react';
import { Redirect } from 'react-router-dom';

import { ReviewContestPopUp } from '../../domain/event/EventReviewContestData';
import ReviewWriteTemplate from '../../components/common/template/ReviewWriteTemplate';

import Reducer from '../../modules/reducers/Reducer';
import ModalContext from '../../modules/contexts/Modalcontext';
import { BANNER_IMG } from '../../lib/image/PCBackgroundImages';
import * as api from '../../lib/api/api';
import { ERROR_RETRY } from '../../lib/Error';
import * as PATH from '../../lib/routes/path';
import {
  AFTER_REVIEW_INDUCE,
  AllowMarketingInduceModal,
  AllowMarketingNotiModal,
  BEFORE_REVIEW_INDUCE,
  doConfirmAllowMarketing,
} from '../../components/common/organism/AllowMarketing';
import { useGetInfo } from '../../Hooks/useGetInfo';
import { doChangeUserAllowMarketing } from '../../lib/util/userContract';
import { Text } from '../../components/common/atom/Text';

const ReviewWriteContainer = ({ match }) => {
  const { id, type } = match.params;

  const [thumbnail, setThumbnail] = useState('');
  const [itemName, setItemName] = useState('');
  const [createDateTime, setCreateDateTime] = useState('');
  const [rate, setRate] = useState(5);
  const [storageRate, setStorageRate] = useState(5);
  const [defaultImages, setDefaultImages] = useState([]);
  const [reviewImages, setReviewImages] = useState([]);
  const [previewReviewImages, setPreviewReviewImages] = useState([]);
  const [toCompleted, setToCompleted] = useState(false);
  const [reviewId, setReviewId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [marketingAgree, setMarketingAgree] = useState(true);
  const [contract, setContract] = useState(false);
  const [isShowAllowMarketing, setIsShowAllowMarketing] = useState(false);
  const [state, setReviewState, onChange] = Reducer({
    communityUrl: '',
    blogUrl: '',
    instagramUrl: '',
    facebookUrl: '',
    text: '',
  });

  const { userInfo } = useGetInfo();
  
  const reviewCategoryType =
    type === 'before' ? 'BABYFACE_BEFORE_BIRTH' : 'BABYFACE_AFTER_BIRTH';

  useEffect(() => {
    setIsShowAllowMarketing(!userInfo.contract.allowMarketing);
    setContract(userInfo.contract);
  }, [userInfo]);

  useEffect(() => {
    api
      .getPurchasedInfo({ purchasedItemId: id, reviewCategoryType })
      .then((response) => {
        setItemName(response.data.itemName);
        setCreateDateTime(response.data.createDateTime);
      });
    api
      .getThumbnail({ name: reviewCategoryType })
      .then((response) => {
        setThumbnail(response.data.thumbnail.storageUri);
      })
      .catch(() => setThumbnail(BANNER_IMG));
    api.getPurchasedImage({ purchasedItemId: id }).then((response) => {
      setDefaultImages(response.data);
    });
  }, []);

  const handleMouseOver = (e) => {
    setRate(Number(e.target.id));
  };

  const handleMouseOut = () => {
    setRate(Number(storageRate));
  };

  const handleClick = (e) => {
    setStorageRate(Number(e.target.id));
  };

  const handleClickHashtag = (e) => {
    setReviewState({
      name: 'text',
      value: state.text.concat(`\n${e.target.innerText}`),
    });
  };

  const handleAgreeCheck = () => {
    setMarketingAgree(marketingAgree === true ? false : true);
  };

  const {
    actions: { onModal },
  } = useContext(ModalContext);

  const handleAllowMarketingCheck = (allowMarketing) => {
    if (doConfirmAllowMarketing(contract.allowMarketing)) {
      doChangeUserAllowMarketing({
        contract,
        allowMarketing,
        afterChangeContract: (data) => {
          setContract(data.contract);
          onModal({
            title: '마케팅 동의 안내',
            content: (
              <AllowMarketingNotiModal
                updateDateTime={data.updateDateTime}
                allowMarketing={data.contract.allowMarketing}
              />
            ),
          });
        },
      });
    }
  };

  const handleDeleteDefaultImage = (id) => {
    const nextImages = defaultImages.filter(
      (defaultImage) => defaultImage.id !== id,
    );
    setDefaultImages(nextImages);
  };

  const handleAddImage = (e) => {
    if (
      reviewImages.length + defaultImages.length + e.target.files.length >
      5
    ) {
      alert('이미지는 최대 5장까지 올릴 수 있습니다.');
    } else {
      for (var i = 0; i < e.target.files.length; i++) {
        let reader = new FileReader();
        let file = e.target.files[i];
        reader.readAsDataURL(file);
        reader.onload = () => {
          setReviewImages((prevState) => [...prevState, file]);
          setPreviewReviewImages((prevState) => [...prevState, reader.result]);
        };
      }
    }
  };

  const handleDeleteAddImage = (index) => {
    const nextImages = reviewImages
      .slice(0, index)
      .concat(reviewImages.slice(index + 1, reviewImages.length));
    const nextPreviewImages = previewReviewImages
      .slice(0, index)
      .concat(previewReviewImages.slice(index + 1, previewReviewImages.length));
    setReviewImages(nextImages);
    setPreviewReviewImages(nextPreviewImages);
  };

  const postReview = async () => {
    const defaultImageIds = defaultImages.length > 0 ? defaultImages[0].id : '';
    const fd = new FormData();

    setLoading(true);

    for (var i = 0; i < reviewImages.length; i++) {
      fd.append('filesToUpload', reviewImages[i], reviewImages[i].name);
    }

    fd.append(
      'review',
      new Blob(
        [
          JSON.stringify({
            star: storageRate,
            text: state.text,
            blogUrl: state.blogUrl,
            communityUrl: state.communityUrl,
            facebookUrl: state.facebookUrl,
            instagramUrl: state.instagramUrl,
            marketingAgree: marketingAgree,
          }),
        ],
        {
          type: 'application/json',
        },
      ),
    );

    await api
      .postReview({
        fd,
        defaultImageIds,
        purchasedItemId: id,
        reviewCategoryType,
      })
      .then((response) => {
        const isShowReviewContestPopUp =
          type === 'after' && contract.allowMarketing;

        onModal({
          title: '리뷰 작성 완료!',
          content: isShowReviewContestPopUp ? (
            <ReviewContestPopUp
              id={response.data.id}
              text={state.text}
              imageUrl={response.data.facetImage.image.storageUri}
            />
          ) : (
            <Text size={14} textAlign="center" lineHeight="1.25rem">
              소중한 후기를 작성해 주셔서 감사합니다.
            </Text>
          ),
          buttonText: '작성한 리뷰 보러가기',
          afterCloseEvent: () => setReviewId(response.data.id),
          afterConfirmEvent: () => setReviewId(response.data.id),
        });
      })
      .catch((error) => {
        alert(ERROR_RETRY);
      })
      .finally(() => setLoading(false));
  };

  const handlePostReview = () => {
    const { title, text } =
      type === 'before' ? BEFORE_REVIEW_INDUCE : AFTER_REVIEW_INDUCE;

    if (state.text.length > 20) {
      if (defaultImages.length + reviewImages.length >= 2) {
        if (!contract.allowMarketing) {
          onModal({
            title,
            content: (
              <AllowMarketingInduceModal
                modalText={text}
                allowMarketing={contract.allowMarketing}
                onClick={() =>
                  handleAllowMarketingCheck(!contract.allowMarketing)
                }
              />
            ),
            afterConfirmEvent: postReview,
            buttonText: '동의하지 않고 리뷰 등록하기',
          });
        } else {
          postReview();
        }
      } else {
        alert('사진을 2장 이상 첨부해주세요.');
      }
    } else {
      alert('후기를 20자 이상 작성해주세요.');
    }
  };

  useEffect(() => {
    reviewId && setToCompleted(true);
  }, [reviewId]);

  return (
    <>
      {toCompleted && <Redirect to={`${PATH.REVIEW_DETAIL}/${reviewId}`} />}
      <ReviewWriteTemplate
        defaultImages={defaultImages}
        thumbnail={thumbnail}
        itemName={itemName}
        createDateTime={createDateTime}
        rate={rate}
        snsUrl={{
          communityUrl: state.communityUrl,
          blogUrl: state.blogUrl,
          instagramUrl: state.instagramUrl,
          facebookUrl: state.facebookUrl,
        }}
        onChange={onChange}
        text={state.text}
        handleMouseOver={handleMouseOver}
        handleMouseOut={handleMouseOut}
        handleClick={handleClick}
        handleClickHashtag={handleClickHashtag}
        handlePostReview={handlePostReview}
        handleDeleteDefaultImage={handleDeleteDefaultImage}
        handleAddImage={handleAddImage}
        handleDeleteAddImage={handleDeleteAddImage}
        previewReviewImages={previewReviewImages}
        loading={loading}
        onCheck={handleAgreeCheck}
        marketingAgree={marketingAgree}
        handleAllowMarketingCheck={handleAllowMarketingCheck}
        allowMarketing={contract.allowMarketing}
        isShowAllowMarketing={isShowAllowMarketing}
        reviewCategoryType={reviewCategoryType}
      />
    </>
  );
};

export default ReviewWriteContainer;
